

export const clearImportFilterData = {
  Bkg: null,
  JobNo: null,
  IP_InvNo: null,
  ScSts: null,
  ShpSts: null,
  ManAccId: null,
  CusId: null,
  AptTmSt: null,
  AptTmEn: null,
  ScId: null,
  CstmClrTmSt: null,
  CstmClrTmEn: null,
  FilterText: "JobNo"
}

export const initImportFilterData = {
  ...clearImportFilterData,
  IsOwnTuk: null,
  ShpSts: "NotFin",
}